/**
 * Garmin-Dateien einlesen — mehrere auf einmal, ohne Duplikate.
 *
 * Der Bestand überschneidet sich stark mit dem, was in den Dateien steht: 314
 * der 358 Tauchgänge des Exports sind schon da. Erkannt wird das über den
 * content_hash, nicht über den Dateinamen oder die Tauchgangsnummer.
 */

import { SPEICHER, alleTauchgaenge } from './db.js';
import { findeOderLege } from './formular.js';
import { normalisiere } from './garmin.js';
import { neueId, speichere } from './saetze.js';

async function lege(db, tauchgang, optionen) {
  const satz = { ...tauchgang, id: neueId() };
  if (satz.site_name) {
    const platz = await findeOderLege(db, SPEICHER.sites, satz.site_name, optionen);
    if (platz.id) satz.site_id = platz.id;
  }
  await speichere(db, SPEICHER.dives, satz, optionen);
}

export async function leseDateien(db, dateien, optionen = {}) {
  const melde = optionen.melde ?? null;
  const bericht = { angelegt: 0, uebersprungen: 0, unlesbar: 0, ohneTauchgang: 0, hinweise: [] };

  // Der Bestand einmal am Anfang; neu Angelegtes kommt unterwegs dazu, damit
  // auch ein Duplikat innerhalb derselben Auswahl erkannt wird.
  const bekannt = new Set(
    (await alleTauchgaenge(db)).map((tg) => tg.content_hash).filter(Boolean),
  );

  for (const [i, datei] of [...dateien].entries()) {
    try {
      const inhalt = JSON.parse(await datei.text());
      const ergebnis = await normalisiere(inhalt);

      if (!ergebnis) {
        bericht.ohneTauchgang += 1;
      } else if (!ergebnis.tauchgang.content_hash) {
        bericht.hinweise.push(`${datei.name}: ${ergebnis.hinweise.join(', ')}`);
      } else if (bekannt.has(ergebnis.tauchgang.content_hash)) {
        bericht.uebersprungen += 1;
      } else {
        await lege(db, ergebnis.tauchgang, optionen);
        bekannt.add(ergebnis.tauchgang.content_hash);
        bericht.angelegt += 1;
      }
    } catch (fehler) {
      bericht.unlesbar += 1;
      bericht.hinweise.push(`${datei.name}: ${fehler.message}`);
    }
    if (melde) melde(i + 1, dateien.length);
  }
  return bericht;
}
